import {Serializables} from "../../../typescript-plugin/entities/Serializables";
import {Van} from "./Van";

export class Vans extends Serializables<Van>{
    protected CreateEntity(): Van {
        return new Van();
    }

    public Remove(removeVan:Van){
        let index = this.items.findIndex(van => {
            return removeVan.id == van.id;
        });
        this.items.splice(index, 1);
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/leasing/Vans.ts